var alignmentStyle = {"alignLeft":"mcmXs","textWrapNowrap":"_76nhl","alignRight":"N3jwf","alignCenter":"_4hIUT","sizeFullWidth":"NImnV","renderedInTable":"_84tkL","sizeOriginal":"M1dtk","sizeContent":"se41S","sizeSmall":"sjkGF","sizeSmallCenter":"unLom","flex":"hO7GG","LEFT":"BlGKt","CENTER":"JDIeG","RIGHT":"B4LzU","AUTO":"SJ8Lz","JUSTIFY":"-weWS"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-fe42602f.js.map
